import { map } from 'lodash'

export default {
  afterCreated () {
    this.$toast.success('Unidade incluida com sucesso.')
    return this.$router.push({name: 'dweller.unit.index'})
  },
  afterUpdated () {
    this.$toast.success('Unidade alterada com sucesso.')
    return this.$router.push({name: 'dweller.unit.index'})
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  },
  getUnits () {
    this.$http.get('/v1/tenant.unit.')
      .then((data) => {
        this.dwellerUnits = data.data
      })
  },
  getTowerUnits (tower) {
    this.loading = true
    this.$http.get('/v1/tenant.unit./tower/' + tower)
      .then(({data}) => {
        const unit = map(data, (item) => {
          return {
            id: item.id,
            label: item.number
          }
        })
        this.dwellerUnits = unit
        this.loading = false
      })
  },
  getTowers () {
    this.$http.get('/v1/dweller/search/tower')
      .then((data) => {
        const optTowers = map(data.data, function (item) {
          return {
            id: item.id,
            label: item.number + ' - ' + item.name
          }
        })
        this.dwellerTowers = optTowers
      })
  },
  availableForTental (remenber) {
    if (remenber) {
      this.unit.available_for_rental = false
    } else {
      this.unit.available_for_rental = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/unit/form/resources/methods.js